import { getEntityActionTypeSelectOptions } from '../../../Entity'
import {
  BUILDINGS_ACTION_ARCHIVE,
  BUILDINGS_ACTION_ARCHIVE_MASS,
  BUILDINGS_ACTION_EDIT_BUILDINGS_GROUP,
  BUILDINGS_ACTION_EDIT_BUILDINGS_GROUP_MASS,
  BUILDINGS_ACTION_EDIT_MANAGERS,
  BUILDINGS_ACTION_EDIT_MANAGERS_MASS,
  BUILDINGS_ACTION_EDIT_PROPERTY_OWNERS,
  BUILDINGS_ACTION_EDIT_PROPERTY_OWNERS_MASS,
  BUILDINGS_ACTION_REMOVE,
  BUILDINGS_ACTION_REMOVE_MASS,
  BUILDINGS_ACTION_RESTORE,
  BUILDINGS_ACTION_RESTORE_MASS,
} from '../../Building.constants'

import { ITEM_ACTION_TYPES } from './useBuildingsActions.constants'

export function getItemActionTypes(availableTypes = ITEM_ACTION_TYPES) {
  return Object.values(getEntityActionTypeSelectOptions()).filter(item =>
    availableTypes.includes(item.value)
  )
}

export function getNotificationTitle({ action, count, t, totalCount }) {
  const types = {
    [BUILDINGS_ACTION_ARCHIVE]: t('Notification.CommonTitleArchivedKey'),
    [BUILDINGS_ACTION_ARCHIVE_MASS]: t(
      'Notification.CommonTitleMassArchivedKey',
      {
        count,
        totalCount,
      }
    ),
    [BUILDINGS_ACTION_EDIT_BUILDINGS_GROUP]: t(
      'Notification.BuildingsTitleEditedBuildingsGroupKey'
    ),
    [BUILDINGS_ACTION_EDIT_BUILDINGS_GROUP_MASS]: t(
      'Notification.BuildingsTitleMassEditedBuildingsGroupKey',
      {
        count,
        totalCount,
      }
    ),
    [BUILDINGS_ACTION_EDIT_MANAGERS]: t(
      'Notification.BuildingsTitleEditedManagersKey'
    ),
    [BUILDINGS_ACTION_EDIT_MANAGERS_MASS]: t(
      'Notification.BuildingsTitleMassEditedManagersKey',
      {
        count,
        totalCount,
      }
    ),
    [BUILDINGS_ACTION_EDIT_PROPERTY_OWNERS]: t(
      'Notification.BuildingsTitleEditedPropertyOwnerKey'
    ),
    [BUILDINGS_ACTION_EDIT_PROPERTY_OWNERS_MASS]: t(
      'Notification.BuildingsTitleMassEditedPropertyOwnerKey',
      {
        count,
        totalCount,
      }
    ),
    [BUILDINGS_ACTION_REMOVE]: t('Notification.CommonTitleRemovedKey'),
    [BUILDINGS_ACTION_REMOVE_MASS]: t(
      'Notification.CommonTitleMassRemovedKey',
      {
        count,
        totalCount,
      }
    ),
    [BUILDINGS_ACTION_RESTORE]: t('Notification.CommonTitleRestoredKey'),
    [BUILDINGS_ACTION_RESTORE_MASS]: t(
      'Notification.CommonTitleMassRestoredKey',
      {
        count,
        totalCount,
      }
    ),
  }

  return types[action] || null
}

export function getAsyncNotificationText({ action, t }) {
  const types = {
    [BUILDINGS_ACTION_ARCHIVE_MASS]: t(
      'Notification.BuildingAsyncTextMassArchiveKey'
    ),
    [BUILDINGS_ACTION_REMOVE_MASS]: t(
      'Notification.BuildingAsyncTextMassRemoveKey'
    ),
    [BUILDINGS_ACTION_RESTORE_MASS]: t(
      'Notification.BuildingAsyncTextMassRestoreKey'
    ),
  }

  return types[action] || null
}
